import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// angular materials
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// ngrx
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OrdersParserService } from 'src/app/core/services/orders-parser';
import { effects, ordersReducers } from 'src/app/store';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '../shared/shared.module';

import { OrderContactsBoxComponent } from './order-contacts-box/order-contacts-box.component';
import { OrderDatesBoxComponent } from './order-dates-box/order-dates-box.component';
import { OrderDetailsBoxComponent } from './order-details-box/order-details-box.component';
import { OrdersComponent } from './orders.component';
import { CheckboxSelectComponent } from './table-page/components';
import { TablePageComponent } from './table-page/table-page.component';
import { ExtendedRowComponent } from './table/extended-row/extended-row.component';
import { OrderTableComponent } from './table/order-table.component';
import { ViewOrderComponent } from './view-order/view-order.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,

    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatGridListModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,

    StoreModule.forFeature('orders', ordersReducers),
    EffectsModule.forFeature(effects),
    CheckboxSelectComponent,
  ],
  providers: [OrdersParserService],
  declarations: [
    OrdersComponent,
    OrderTableComponent,
    ExtendedRowComponent,
    ViewOrderComponent,
    OrderDetailsBoxComponent,
    TablePageComponent,
    OrderContactsBoxComponent,
    OrderDatesBoxComponent,
  ],
  exports: [OrdersComponent],
})
export class OrdersTableModule {}
